import { utils as dataUtils } from '@easydata/core';
var EqServerValueListResolver = /** @class */ (function () {
    function EqServerValueListResolver(context) {
        this.context = context;
    }
    EqServerValueListResolver.prototype.loadValueList = function (options) {
        var modelId = options.modelId || this.context.getModel().getId();
        var requestData = dataUtils.assign({ modelId: modelId }, options.params);
        var editorId = requestData.editorId;
        var http = this.context.getServices().getHttpClient();
        var url = this.context.resolveEndpoint('GetValueList', { modelId: modelId, listId: editorId });
        var queryParams = {};
        if (options && options.params && options.params.queryParams) {
            queryParams = options.params.queryParams;
        }
        return http.get(url, { queryParams: queryParams })
            .then(function (responseData) {
            if (responseData && responseData.values) {
                return responseData.values;
            }
            else {
                throw new Error('Wrong response format. No "values" property');
            }
        });
    };
    return EqServerValueListResolver;
}());
export { EqServerValueListResolver };
//# sourceMappingURL=eqs_value_list_resolver.js.map